//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "UmbilicalLine_info",
  data() {
    return {};
  },
  components: {},
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pedi/UmbilicalLine_info.vue